import React from 'react';

const MoveOutIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fillRule='evenodd'>
      <g fill='#111' fillRule='nonzero'>
        <path d='M23 7c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2H9c-1.105 0-2-.895-2-2v-3h2v3h14V9H9v3H7V9c0-1.105.895-2 2-2h14zm-9.918 3.666l.09.084 4.303 4.564c.332.353.36.888.083 1.271l-.083.101-4.303 4.564-.04.04c-.361.34-.913.351-1.286.044l-.089-.084-.06-.064c-.333-.353-.36-.888-.083-1.271l.083-.101L14.35 17H8c-.552 0-1-.448-1-1s.448-1 1-1h6.35l-2.653-2.814c-.333-.353-.36-.888-.083-1.271l.083-.101.1-.104c.361-.34.913-.351 1.285-.044z' />
      </g>
    </g>
  </svg>
);

export default MoveOutIcon;
